import { render } from "./MedicationList.vue?vue&type=template&id=36ba09d8&scoped=true"
import script from "./MedicationList.vue?vue&type=script&lang=js"
export * from "./MedicationList.vue?vue&type=script&lang=js"

import "./MedicationList.vue?vue&type=style&index=0&id=36ba09d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ba09d8"]])

export default __exports__